import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "../models/cores/AuthState.model";
const initialState: AuthState = {token: null, roles: [], permissions: [], username: null, isAuthenticated: null, userId: undefined, permissionsLoaded: false};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state,action: PayloadAction<{token: string; roles: string[]; username: string; userId : string}>) => {
      state.token = action.payload.token;
      state.roles = action.payload.roles;
      state.username = action.payload.username;
      state.isAuthenticated = true;
      state.userId = action.payload.userId;
    },
    setPermissions: (state, action: PayloadAction<string[]>) => {
      state.permissions = action.payload;
      state.permissionsLoaded = true;
    },
    logout: (state) => {
      state.token = null;
      state.roles = [];
      state.permissions = [];
      state.username = null;
      state.isAuthenticated = false;
      state.userId = undefined;
      state.permissionsLoaded = false;
    },
  },
});

export const { setCredentials, setPermissions, logout } = authSlice.actions;
export default authSlice.reducer;
